import { Static, String, Number, Array, Object, Optional, Record, Enum } from '@sinclair/typebox';

import { BaggageUnitType } from './common';

export type ShortRule = Static<typeof ShortRule>;
export const ShortRule = Object({
  id: String(),
  iconName: String(),
  text: String(),
  iconId: String(),
});

export type FareRules = Static<typeof FareRules>;
export const FareRules = Object({
  id: String(),
  name: String(),
  cabin: String(),
  shortRules: Array(ShortRule),
  longRules: Array(String()),
  rank: Optional(Number()),
});

export type FareRuleMap = Static<typeof FareRuleMap>;
export const FareRuleMap = Record(String(), FareRules);

export type BaggageAllowance = Static<typeof BaggageAllowance>;
export const BaggageAllowance = Object({
  unit: Enum(BaggageUnitType),
  value: Number(),
  text: String(),
});

export type RoundTripBaggageAllowance = Static<typeof RoundTripBaggageAllowance>;
export const RoundTripBaggageAllowance = Object({
  outbound: Optional(BaggageAllowance),
  inbound: Optional(BaggageAllowance),
});
